export default __webpack_public_path__ + "static/media/105.156ea72a.jpg";